import request from '../utils/request';

//设置分成
export function cashsetting(data) {
    return request({
        url: 'home/cashsetting/save',
        method: 'post',
        data: data,
    });
}
//获取分成
export function cashInfo(data) {
    return request({
        url: 'home/cashsetting/info',
        method: 'post',
        data: data,
    });
}
//获取提现列表
export function bankList(data) {
    return request({
        url: 'home/bank/list',
        method: 'post',
        data: data,
    });
}
//获取提现列表
export function updateStatus(data) {
    return request({
        url: 'home/bank/up_status',
        method: 'post',
        data: data,
    });
}
//获取打款金额
export function getdkmoney(params) {
    return request({
        url: 'home/cashsetting/auto_pay',
        method: 'get',
        params: params,
    });
}
//设置打款金额
export function setdkmoney(data) {
    return request({
        url: 'home/cashsetting/auto_pay',
        method: 'post',
        data: data,
    });
}
//获取服务商价格
export function getsermoney(params) {
    return request({
        url: 'home/cashsetting/service_price',
        method: 'get',
        params: params,
    });
}
//设置服务商价格
export function setsermoney(data) {
    return request({
        url: 'home/cashsetting/service_price',
        method: 'post',
        data: data,
    });
}
//设置服务商价格
export function bankAdd(data) {
    return request({
        url: 'home/bank/add',
        method: 'post',
        data: data,
    });
}
